// import AddSvgComponent from "@assets/svg-components/add";
// import ExpenseSvgComponent from "@assets/svg-components/sidebar/expense";
// import { getValue } from "@utils/lodash";
// import React from "react";
// import { useNavigate } from "react-router-dom";

// function ReportExpenseHeaderSection(props: any) {
//   const { params, setShowUpdatePopup, showUpdatePopup, formInfo } = props;
//   const navigate = useNavigate();
//   console.log(props, "---PROPS ReportExpenseHeaderSection---");
//   return (
//     <>
//       {getValue(formInfo, `approval_status`, "") !== "reimbursed" && (
//         <div className="header_button_container d-flex justify-content-between reports-details-under-navtab-header">
//           <div></div>
//           <div className="d-flex">
//             <div
//               className={`text_button_container d-flex justify-content-between align-items-center ${
//                 props.disabled ? "bg-disabled" : ""
//               }`}
//               onClick={() =>
//                 !props.disabled &&
//                 navigate(`/client/expenses/add?expense_report_id=${params.id}`)
//               }
//             >
//               <AddSvgComponent color={!props.disabled ? "gray" : "#d5d5d5"} />
//               <p className="">New Expense</p>
//             </div>
//             <div
//               className={`text_button_container d-flex justify-content-between align-items-center  ${
//                 props.disabled ? "bg-disabled" : ""
//               }`}
//               onClick={() => {
//                 !props.disabled && setShowUpdatePopup(!showUpdatePopup);
//               }}
//             >
//               <ExpenseSvgComponent
//                 color={!props.disabled ? "gray" : "#d5d5d5"}
//               />
//               <p className="">Add Unreported Expense</p>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default ReportExpenseHeaderSection;

import AddSvgComponent from '@assets/svg-components/add';
import ExpenseSvgComponent from '@assets/svg-components/sidebar/expense';
import { getValue } from '@utils/lodash';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

function ReportExpenseHeaderSection(props: any) {
  const {
    params,
    setShowUpdatePopup,
    showUpdatePopup,
    formInfo,
    length,
    createdFor,
  } = props;
  const navigate = useNavigate();

  const createdForSuffix =
    createdFor && createdFor.id !== 'self'
      ? `&created_for=${createdFor.id}`
      : '';

  // Check if we should disable buttons based on expense report limit
  const expenseLimit = getValue(
    formInfo,
    'created_by.policy.expense_report_entry_limit',
    0,
  );
  const isLimitReached = length >= expenseLimit;
  const isDisabled = props.disabled || isLimitReached;

  const tooltipMessage = isLimitReached
    ? `Your expense addition limit is ${expenseLimit} expenses per report`
    : '';

  return (
    <>
      {getValue(formInfo, `approval_status`, '') !== 'reimbursed' && (
        <>
          {/* <div className="alert alert-primary mx-4 mt-2 mb-0 p-2 fs-8 text-center" role="alert">
            Your expense addition limit is {expenseLimit} expenses per report
          </div> */}

          <div className="header_button_container d-flex justify-content-between reports-details-under-navtab-header pb-2">
            <div></div>
            <div className="d-flex">
              <div
                className={`text_button_container d-flex justify-content-between align-items-center ${
                  isDisabled ? 'bg-disabled' : ''
                }`}
                onClick={() =>
                  !isDisabled &&
                  navigate(
                    `/client/expenses/add?expense_report_id=${params.id}${createdForSuffix}`,
                  )
                }
                data-tooltip-id="expense-limit-tooltip"
                data-tooltip-content={tooltipMessage}
                data-tooltip-place="bottom"
              >
                <AddSvgComponent color={!isDisabled ? 'gray' : '#d5d5d5'} />
                <p className="">New Expense</p>
              </div>
              <div
                className={`text_button_container d-flex justify-content-between align-items-center  ${
                  isDisabled ? 'bg-disabled' : ''
                }`}
                onClick={() => {
                  !isDisabled && setShowUpdatePopup(!showUpdatePopup);
                }}
                data-tooltip-id="expense-limit-tooltip"
                data-tooltip-content={tooltipMessage}
                data-tooltip-place="bottom"
              >
                <ExpenseSvgComponent color={!isDisabled ? 'gray' : '#d5d5d5'} />
                <p className="">Add Unreported Expense</p>
              </div>
            </div>
          </div>

          <div
            className="d-flex justify-content-center mt-2 border mx-4 mt-2 mb-0 p-1 rounded"
            style={{ backgroundColor: '#f8f8f8' }}
          >
            <span className="text-muted" style={{ fontSize: '12px' }}>
              Your expense addition limit is <strong>{expenseLimit}</strong>{' '}
              expenses per report
            </span>
          </div>

          {/* Add the Tooltip component */}
          <Tooltip
            id="expense-limit-tooltip"
            className="tooltip-custom"
            openOnClick={false}
            delayShow={100}
          />
        </>
      )}
    </>
  );
}

export default ReportExpenseHeaderSection;
